// src/pages/Books.js
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "../App.css";

const Books = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  // ─── Hero banner images ────────────────────────────────────────
  const bannerImages = ["/images/books-banner.jpg"];
  const [currentBanner, setCurrentBanner] = useState(0);

  useEffect(() => {
    if (bannerImages.length > 1) {
      const iv = setInterval(
        () => setCurrentBanner((i) => (i + 1) % bannerImages.length),
        5000
      );
      return () => clearInterval(iv);
    }
  }, [bannerImages.length]);

  // ─── Book data ────────────────────────────────────────────────
  const rawBooks = [
    {
      id: 1,
      title: t("book1Title"),
      subtitle: t("book1Subtitle"),
      excerpt: t("book1Desc"),
      blurb: t("book1Blurb"),
      image: "/images/book1.jpg",
    },
    {
      id: 2,
      title: t("book2Title"),
      subtitle: t("book2Subtitle"),
      excerpt: t("book2Desc"),
      blurb: t("book2Blurb"),
      image: "/images/book2.jpg",
    },
    {
      id: 3,
      title: t("book3Title"),
      subtitle: t("book3Subtitle"),
      excerpt: t("book3Desc"),
      blurb: t("book3Blurb"),
      image: "/images/book3.jpg",
    },
    {
      id: 4,
      title: t("book4Title"),
      subtitle: t("book4Subtitle"),
      excerpt: t("book4Desc"),
      blurb: t("book4Blurb"),
      image: "/images/book4.jpg",
    },
  ];

  const [openId, setOpenId] = useState(null);
  const toggleOpen = (id) => setOpenId((prev) => (prev === id ? null : id));

  return (
    <div
      className={`container ${isRTL ? "arabic-font" : ""}`}
      style={{ direction: isRTL ? "rtl" : "ltr" }}
    >
      {/* ─── Hero Banner (full width, auto height) ─────────────────── */}
      <div style={{ marginBottom: "2rem" }}>
        <img
          src={bannerImages[currentBanner]}
          alt="Books Banner"
          style={{
            width: "100%",
            height: "auto",
            borderRadius: "12px",
          }}
        />
      </div>

      {/* ─── Page Heading ───────────────────────────────────────────── */}
      <h1 className="storybook-heading">{t("booksTitle")}</h1>
      <p
        style={{
          maxWidth: "720px",
          marginBottom: "2rem",
          color: "#4b5563",
        }}
      >
        {t("booksIntro")}
      </p>

      {/* ─── Book Cards: 4 columns, equal size ──────────────────────── */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: "1.5rem",
        }}
      >
        {rawBooks.map((book) => {
          const expanded = openId === book.id;
          return (
            <div key={book.id} className="card" style={{ padding: "1rem" }}>
              <img
                src={book.image}
                alt={book.title}
                style={{
                  width: "100%",
                  height: "200px",
                  objectFit: "cover",
                  borderRadius: "12px",
                  marginBottom: "0.75rem",
                }}
              />
              <h2
                style={{
                  color: "#F4888C",
                  fontSize: "1.25rem",
                  margin: "0.5rem 0 0.25rem",
                }}
              >
                {book.title}
              </h2>
              <p style={{ margin: "0.25rem 0", fontWeight: "500" }}>
                {book.subtitle}
              </p>
              <p style={{ color: "#4b5563", whiteSpace: "pre-line", margin: "0.5rem 0" }}>
                {expanded ? book.blurb : book.excerpt}
              </p>
              <button
                className="btn grey-btn"
                style={{ margin: "0.25rem 0" }}
                onClick={() => toggleOpen(book.id)}
              >
                {expanded ? t("bookReadLess") : t("bookReadMore")}
              </button>
              <button
                className="btn"
                style={{ margin: "0.5rem 0 0" }}
                onClick={() => alert(t("bookBuySoon"))}
              >
                {t("buyNow")}
              </button>
            </div>
          );
        })}
      </div>

      {/* ─── Contact CTA ────────────────────────────────────────────── */}
      <div className="card" style={{ textAlign: "center", marginTop: "2.5rem" }}>
        <p>📦 {t("booksContactText")}</p>
        <a
          href="mailto:info@mydearteachermovement.com"
          style={{
            fontWeight: "bold",
            color: "#3bc6c7",
            textDecoration: "none",
          }}
        >
          {t("getInTouch")}
        </a>
      </div>
    </div>
  );
};

export default Books;
